<div class="mb-4">
  <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
</div>

<ngb-tabset #tabs="ngbTabset" [destroyOnHide]="false" [activeId]="selectedTab" (tabChange)="selectTab($event?.nextId)">
  <ngb-tab id="details" [title]="'CORPORATE_DETAIL.TABS.DETAILS' | translate">
    <ng-template ngbTabContent>
      <ng-container *ngIf="isCorporateLoaded">
        <app-add-or-edit-corporate
          [isModal]="false"
          [corporate]="corporate"
          (emitSaveCorporate)="onSaveCorporate()">
        </app-add-or-edit-corporate>
      </ng-container>
      <ng-container *ngIf="!isCorporateLoaded">
        <div class="card">
          <div class="card-body">
            <div class="loader-wrapper">
              <app-loader></app-loader>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </ngb-tab>
  <ngb-tab id="programs" [title]="'CORPORATE_DETAIL.TABS.PROGRAMS' | translate">
    <ng-template ngbTabContent>
      <app-discounts-form
        [discounts]="discounts"
        [showAddedEditedLoader]="showAddedEditedLoaderInDiscountForm"
        [showRemovedLoader]="showRemovedLoaderInDiscountForm"
        (emitAddDiscount)="addDiscount($event)"
        (emitEditDiscount)="editDiscount($event)"
        (emitRemoveDiscount)="removeDiscount($event)"
      ></app-discounts-form>
    </ng-template>
  </ngb-tab>
  <ngb-tab id="managers" [title]="'CORPORATE_DETAIL.TABS.MANAGERS' | translate">
    <ng-template ngbTabContent>
      <app-profile-list
        *ngIf="corporate.id"
        [corporateID]="corporate.id"
        [profiles]="managers"
        [role]="'ROLES.MANAGER' | translate">
      </app-profile-list>
    </ng-template>
  </ngb-tab>
  <ngb-tab id="travelers" [title]="'CORPORATE_DETAIL.TABS.TRAVELERS' | translate">
    <ng-template ngbTabContent>
      <app-profile-list
        *ngIf="corporate.id"
        [corporateID]="corporate.id"
        [profiles]="travelers"
        [role]="'ROLES.TRAVELER' | translate">
      </app-profile-list>
    </ng-template>
  </ngb-tab>
</ngb-tabset>
